import { ComponentsModule } from '../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { ProjectsPage } from './projects';
import { SellionsLayoutRendererLibModule } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';

@NgModule({
  declarations: [ProjectsPage],
  imports: [
    ComponentsModule,
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(ProjectsPage),
  ],
})
export class ProjectListModule {}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/project-list/projects.module.ts